import React from 'react'
import {
    Box,
    HStack,
    Text,
    useMultiStyleConfig,
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage, useIntl} from 'react-intl'
import PropTypes from 'prop-types'

//ICONS
import {ShippingIcon, CloseIcon} from '../../../components/icons'

const CartShipping = ({onClose}) => {
    const style = useMultiStyleConfig('Cart', {})
    const {shipping} = style
    const {formatMessage} = useIntl()

    const handleClose = () => {
        onClose()
    }
    return (
        <Box {...shipping?.shippingContainer}>
            <HStack {...shipping?.shippingContent}>
                <ShippingIcon {...shipping?.shippingIcon} />
                <Text {...shipping?.shippingText}>
                    <FormattedMessage
                        id="cart_default.cart_shipping.message"
                        defaultMessage="Free shipping for orders over 30€"
                    />
                </Text>
            </HStack>
            <Box>
                <CloseIcon
                    onClick={handleClose}
                    {...shipping?.closeIcon}
                    role="button"
                    aria-label={formatMessage({
                        id: 'cart_shipping.button.close.label',
                        defaultMessage: 'Close shipping information',
                    })}
                    tabIndex={0}
                />
            </Box>
        </Box>
    )
}

export default CartShipping

CartShipping.propTypes = {
    onClose: PropTypes.func.isRequired,
}
